import { html } from '@shared/utils/rendering/html';
import { Icon, IconNames } from '@shared/components/icons';

import ActionsDropdown from '@shared/components/dropdowns/actions-dropdown';
import ActionsDropdownItem from '@shared/components/dropdowns/actions-dropdown/actions-dropdown-item';

export default function SystemsTableActions(row) {
    return html`
        <${ActionsDropdown}>
            <${ActionsDropdownItem}
                disabled=${false}
                onClickEvent=${() => {}}
                href='/Admin/Systems/${row.systemId}'
                params=${null}
                label=${{
                    text: 'Edit System',
                    icon: html`<${Icon} name=${IconNames.Edit} />`,
                }}
            />
        </${ActionsDropdown}>
    `;
}
